export const getCompanyColumns = () => {
    return [
        { headerName: "Type", key: "type" },
        { headerName: "Period", key: "period" },
        { headerName: "Start Date", key: "start_date" },
        { headerName: "End Date", key: "end_date" },
        { headerName: "Company Contribution", key: "company_contribution" },
        { headerName: "Description", key: "description" },
        { headerName: "", key: "action" },
    ];
}

export const getEmployeeColumns = () => {
    return [
        { headerName: "Employee", key: "employee" },
        { headerName: "Type", key: "type" },
        { headerName: "Period", key: "period" },
        { headerName: "Start Date", key: "start_date" },
        { headerName: "End Date", key: "end_date" },
        { headerName: "Company Contribution", key: "company_contribution" },
        { headerName: "Employee Contribution", key: "employee_contribution" },
        { headerName: "Description", key: "description" },
        { headerName: "", key: "action" },
    ];
}